/**
 * converts location search params string to an object
 *
 * @param {string} search ex: window.location.search or state.router.location.search
 * @return {object} ex: "{location: 'ny', debug: 'true'}"
 */
export function getLocationParams(search: string): { [key: string]: string } {
  if (!search) return {};
  return search
    .slice(1)
    .split('&')
    .reduce((acc, str) => {
      const [key, val] = str.split('=');
      return Object.assign(acc, { [key]: val });
    }, {});
}
